var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"track-account-page-load",rawName:"v-track-account-page-load:retro-credit",arg:"retro-credit"}],staticClass:"retro-credit-page"},[_c('cmg-retro-credit',{staticClass:"retro-credit"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }